import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { getTestId } from '../../utils/testUtils';

interface SubmitButtonProps {
  onSubmit: () => void;
  isDisabled: boolean;
  isLoading: boolean;
  buttonText?: string;
  isAlreadySubmitted?: boolean; // New prop to track if the question has already been submitted
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({ 
  onSubmit, 
  isDisabled,
  isLoading,
  buttonText = 'Submit',
  isAlreadySubmitted = false // Default to false
}) => {
  console.log('[SubmitButton] Props:', {
    isDisabled,
    isLoading,
    buttonText,
    isAlreadySubmitted,
  });
  // If the button's primary action is 'Continue', don't show the 'Submitted' state.
  const showSubmittedState = isAlreadySubmitted && buttonText !== 'Continue';
  console.log('[SubmitButton] Calculated showSubmittedState:', showSubmittedState);

  return (
    <Button
      variant="contained"
      color={showSubmittedState ? "secondary" : "primary"}
      onClick={onSubmit}
      disabled={isDisabled || isLoading || showSubmittedState}
      sx={{ 
        minWidth: 120,
        opacity: showSubmittedState ? 0.7 : 1, // Reduce opacity for already submitted buttons
        cursor: showSubmittedState ? 'default' : 'pointer'
      }}
      {...getTestId('submit-button')}
    >
      {isLoading ? <CircularProgress size={24} /> : (showSubmittedState ? 'Submitted' : buttonText)}
    </Button>
  );
};